const levelTypes = {
    NONE: 0,
    ERROR: 1,
    WARNING: 2,
    INFO: 3,
    DEBUG: 4,
    V1: 5,
    V2: 6
};

export default class Logger {
    /**
     * Log constructor
     * @param {Object} options
     */
    constructor(options) {
        const defaultOptions = {
            debugLevel: 0
        };
        this.options = Object.assign(defaultOptions, options);
        this.currentLevel = 0;

        // IE8 has no console unless it is opened in advance.
        // IE9 console methods are not Functions and have no bind.
        if (window.console && window.console.log.bind) {
            this.alwaysWarn = console.warn.bind(console);
            this.setLevel(this.options.debugLevel);
        }
    }

    /**
     * Set debug level
     * @param {number} level
     */
    setLevel(level) {
        const nop = function () {};

        this.currentLevel = level;

        this.error = (level >= levelTypes.ERROR) ? console.error.bind(console) : nop;
        this.warning = (level >= levelTypes.WARNING) ? console.warn.bind(console) : nop;
        this.info = (level >= levelTypes.INFO) ? console.info.bind(console) : nop;
        this.debug = (level >= levelTypes.DEBUG) ? console.log.bind(console) : nop;
    }

    /**
     * @returns {number} The debug level
     */
    getLevel() {
        return this.currentLevel;
    }

    /* eslint-disable lines-between-class-members, class-methods-use-this  */
    alwaysWarn() {}
    error() {}
    warning() {}
    info() {}
    debug() {}
}

Logger.levelTypes = levelTypes;
